import { X, FileText, Table } from 'lucide-react';

export default function ExportFormatModal({ open, onClose, onPDF, onExcel, label = 'Relatório', loadingExcel }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.45)' }} onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
          <div>
            <p className="text-xs text-slate-400 font-medium uppercase tracking-wider">Exportar</p>
            <h3 className="font-bold text-slate-800 text-base leading-tight">{label}</h3>
          </div>
          <button onClick={onClose} className="p-1.5 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="p-5">
          <p className="text-sm text-slate-500 mb-4">Como deseja exportar este relatório?</p>
          <div className="grid grid-cols-2 gap-3">
            <button onClick={() => { onPDF(); onClose(); }}
              className="flex flex-col items-center gap-2.5 p-4 rounded-xl border-2 border-slate-200 hover:border-red-400 hover:bg-red-50 transition-all group">
              <div className="w-10 h-10 rounded-xl bg-red-100 group-hover:bg-red-200 flex items-center justify-center transition-colors">
                <FileText className="w-5 h-5 text-red-600" />
              </div>
              <div className="text-center">
                <p className="font-semibold text-slate-700 text-sm">PDF</p>
                <p className="text-xs text-slate-400">Para impressão</p>
              </div>
            </button>
            <button onClick={() => { onExcel(); onClose(); }} disabled={loadingExcel}
              className="flex flex-col items-center gap-2.5 p-4 rounded-xl border-2 border-slate-200 hover:border-emerald-500 hover:bg-emerald-50 transition-all group disabled:opacity-60">
              <div className="w-10 h-10 rounded-xl bg-emerald-100 group-hover:bg-emerald-200 flex items-center justify-center transition-colors">
                <Table className="w-5 h-5 text-emerald-600" />
              </div>
              <div className="text-center">
                <p className="font-semibold text-slate-700 text-sm">Excel</p>
                <p className="text-xs text-slate-400">Planilha .xlsx</p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
